export const gems = () => ({
    gem: (gemId: string) => `/gems/${gemId}`,
    metadata: (id: string) => `/artifacts/tables/Gems/${id}/metadata`,
    status: () => `/gems/status`,
    all: () => '/gems',
    userGems: () => '/user/gems',
    fragment: (id: string) => `/gems/${id}/fragments`,
    fragmentsHeld: () => `/gem_fragments/held`,
});
